import React, { useContext, useEffect, useState } from "react";
import { FaTimes } from "react-icons/fa";
import "../../styles/components-styles/sidebar-styles/UserProfileSidebar.css";
import { SidebarContext } from "../../contexts/SidebarContext";
import { handlePayment } from "../../services/paymentService";
import { useNavigate } from "react-router-dom";
import axios from "axios";

function UserProfileSidebar() {
    const { toggleShowUserProfileSidebar, showUserProfileSidebar } = useContext(SidebarContext);
    const [darkMode, setDarkMode] = useState(false);
    const navigate = useNavigate();
    const [userProfile, setUserProfile] = useState({});

    const handleFetchUserProfile = async () => {
      const userId = sessionStorage.getItem("userId");

      try {
          const response = await axios.get(`/user/getUserProfile/${userId}`);

          if (response.status === 200) {
            setUserProfile(response.data.user)
          }

      } catch (err) {
          // if (err.response && err.response.status === 402) {
          //     } else {
              // Handle other errors if needed
              console.error("Error fetching user profile:", err);
              // Optionally set an error state to display a message to the user
          // }

      } finally {
      }
  };

  const toggleDarkMode = () => setDarkMode(!darkMode);

  const handleNavigateToSubscriptionPage = async () => {
          toggleShowUserProfileSidebar()
          const userId = sessionStorage.getItem("userId");
  
          try {
              const response = await axios.get(`/user/getUserProfile/${userId}`);
  
              if (response.status === 200) {
                  if (response.data.user.currentPlan === "Free") {
                    navigate("/dashboard/subscribe")
                  } 
                  if (response.data.user.currentPlan === "Premium") {
                      navigate("/dashboard/alreadysubscribed");
                  }
              }
  
          } catch (err) {
              if (err.response && err.response.status === 402) {
                  navigate("/dashboard/subscribe"); // Keep this in case your backend also sends 402 for this route in the future
              } else {
                  // Handle other errors if needed
                  console.error("Error fetching user profile:", err);
                  // Optionally set an error state to display a message to the user
              }
  
          } finally {
          }
  };

  const handleLogout = async () => {
    const token = sessionStorage.getItem("token");

    try {
      await axios.post("/user/logout", {}, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      sessionStorage.removeItem("token");
      sessionStorage.removeItem("userId");
      navigate("/");
    } catch (error) {
      console.error("Logout failed:", error);
      alert("Logout failed. Please try again.");
    }
  };


  useEffect(() => {
    handleFetchUserProfile();
  }, [])

  return (
    <div
      className={`user-profile-sidebar ${
        showUserProfileSidebar ? "open" : "closed"
      }`}
    >
      <div className="user-profile-sidebar-header">
        <span className="user-email">{userProfile.email}</span>
        <FaTimes
          className="close-icon"
          onClick={toggleShowUserProfileSidebar}
        />
      </div>

        <ul className="user-profile-sidebar-list">
          {/* {/* <li className="user-profile-sidebar-item">My resources</li> */}
                {/* <li className="user-profile-sidebar-item">Install app</li> */}
                {/* <li className="user-profile-sidebar-item">
                    Dark mode
                    <label className="user-profile-switch">
                        <input type="checkbox" checked={darkMode} onChange={toggleDarkMode} />
                        <span className="user-profile-slider"></span>
                    </label>
                </li> */}
                {/* <li className="user-profile-sidebar-item">Settings</li> */}
                {/* <li className="user-profile-sidebar-item">Messages</li> */} 
          <li 
            className="user-profile-sidebar-item"
            onClick={() => {
              navigate("/dashboard/faq")
              toggleShowUserProfileSidebar()
            }} 
            >FAQs</li>
          <li 
            className="user-profile-sidebar-item"
            onClick={() => {
              navigate("/dashboard/contact")
              toggleShowUserProfileSidebar()
            }}
          >Contact us</li>
          <li 
              className="user-profile-sidebar-item"
              onClick={handleNavigateToSubscriptionPage}>Subscribe
          </li>
          <li className="user-profile-sidebar-item" onClick={handleLogout}>Log out</li>
        </ul>
      </div>
    );
}

export default UserProfileSidebar;
